import useAxios from 'hooks/useAxios';

/**
 * Admin function to connect any user with an affiliate code.
 */
export async function connectUserAffiliateCodeAdmin(userId, affiliateCode) {
  const api = useAxios();

  try {
    const res = await api.post(`/users/${userId}/connect-affiliate-code`, {
      affiliateCode: affiliateCode,
    });
    return res;
  } catch (err) {
    return err;
  }
}
